import React, { useState } from "react";
import QRCode from "react-qr-code";
import QRCodeLib from "qrcode";
import { jsPDF } from "jspdf";

import logo from "../../assets/logo128x128.png";
import { generateAgreement } from "./PDPartnerAgreement";

const PDPartnerCertificate = ({form,hasDirector,hasCoordinator,hasInfluencer}) => {
  const [showCertificate, setShowCertificate] = useState(true);
  const [showDocument, setShowDocument] = useState(true);
  const [localSelectedRolePrint, setLocalSelectedRolePrint] = useState(null);
  const [localSelectedRoleAgreement, setLocalSelectedRoleAgreement] = useState(null);
  const [activeDocument, setActiveDocument] = useState(null);  // CERTIFICATE | AGREEMENT
  const [selectedRole, setSelectedRole] = useState(null); // DIRECTOR | COORDINATOR | INFLUENCER
  const currentRole = selectedRole || localSelectedRolePrint || localSelectedRoleAgreement;

  const handleDownloadPDF = async (role) => {
    const pdf = new jsPDF("p", "mm", "a4");

    const pageWidth = 210;
    const pageHeight = 297;

    // ===== BACKGROUND =====
    pdf.setFillColor(255, 255, 255);
    pdf.rect(0, 0, pageWidth, pageHeight, "F");

    // ===== GOLD BORDER (DOUBLE LAYER) =====
    pdf.setDrawColor(212, 175, 55);
    pdf.setLineWidth(2);
    pdf.rect(10, 10, 190, 277);

    pdf.setLineWidth(0.5);
    pdf.rect(14, 14, 182, 269);

    // ===== TITLE =====
    pdf.setFont("times", "bold");
    pdf.setFontSize(22);
    pdf.setTextColor(184, 134, 11);
    pdf.text("OFFICIAL CERTIFICATE", 105, 40, { align: "center" });

    // Subtitle
    pdf.setFont("times", "normal");
    pdf.setFontSize(12);
    pdf.setTextColor(80, 80, 80);
    pdf.text("Think5Whys Global Certification Authority", 105, 50, {
      align: "center",
    });

    // ===== USER NAME =====
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(24);
    pdf.setTextColor(0, 0, 0);
    pdf.text(form?.userName || "USER NAME", 105, 85, { align: "center" });

    // ID
    pdf.setFontSize(12);
    pdf.setTextColor(100, 100, 100);
    pdf.text(`ID: ${form?.userCode || "-"}`, 105, 95, {
      align: "center",
    });

    // ===== ROLE BADGE =====
    pdf.setFillColor(212, 175, 55);
    pdf.roundedRect(60, 110, 90, 12, 6, 6, "F");

    pdf.setFontSize(12);
    pdf.setTextColor(0, 0, 0);
    pdf.text(`${role || "ROLE"} CERTIFICATE`, 105, 118, 
      { align: "center" }
    );

    // ===== LOGO =====
    const img = new Image();
    img.src = logo;

    await new Promise((resolve) => {
      img.onload = resolve;
    });

    const topMargin = 140;
    pdf.addImage(img, "PNG", 92, topMargin, 25, 25);

    // ===== VERIFIED TEXT =====
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(11);
    pdf.setTextColor(0, 120, 0);

    const verifiedY = 200;
    pdf.text("Think5Whys Verified", 105, verifiedY, { align: "center" });

    
    const qrData = JSON.stringify({
      name: form?.userName,
      code: form?.userCode,
      role: role,
    });

    const qrImage = await QRCodeLib.toDataURL(qrData);

    const qrSize = 35; // mm
    const x = (pageWidth - qrSize) / 2;
    const y = verifiedY + 10;

    pdf.addImage(qrImage, "PNG", x, y, qrSize, qrSize);

    // ===== FOOTER TEXT =====
    pdf.setFontSize(10);
    pdf.text(
      "This certificate is system generated and digitally verified.",
      105,
      250,
      { align: "center" }
    );

    pdf.setFontSize(8);
    pdf.setTextColor(150, 150, 150);
    pdf.text(
      "© Think5Whys Global DeepTech Solutions Private Limited, Mumbai, India • All Rights Reserved",
      105,
      260,
      { align: "center" }
    );

    // ===== SAVE =====
    pdf.save(
      `Think5Whys-Certificate-${localSelectedRolePrint || "ROLE"}-${
        form?.userCode || "user"
      }.pdf`
    );
  };

  const handleDownloadAgreement = async (role) => {

  const pdf = new jsPDF("p", "mm", "a4");

  const agreementData = generateAgreement({
    role,
    userName: form?.userName,
    userCode: form?.userCode,
    city: form?.city,
    state: form?.state,
    country: form?.country,
    pincode: form?.pincode,
  });

  if (!agreementData) {
    alert("Agreement data not found");
    return;
  }

  const pageWidth = 210;
  const margin = 15;
  const lineHeight = 6;

  // ===== HEADER =====

  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(16);

  pdf.text(
    String(agreementData.title || "PARTNER AGREEMENT"),
    pageWidth / 2,
    20,
    { align: "center" }
  );

  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(10);

  pdf.text(
    "Think5Whys Global DeepTech Solutions Private Limited",
    pageWidth / 2,
    28,
    { align: "center" }
  );

  pdf.text(
    "Mumbai, India • www.think5whys.com",
    pageWidth / 2,
    34,
    { align: "center" }
  );

  // ===== AGREEMENT CONTENT =====

  const lines = pdf.splitTextToSize(
    String(agreementData.content || ""),
    180
  );

  let y = 45;

  lines.forEach((line) => {

    if (y > 270) {
      pdf.addPage();
      y = 20;
    }

    pdf.text(String(line), margin, y);
    y += lineHeight;

  });

  // ===== SIGNATURE SECTION =====

  y += 15;

  if (y > 240) {
    pdf.addPage();
    y = 40;
  }

  pdf.line(20, y, 80, y);
  pdf.line(130, y, 190, y);

  pdf.setFontSize(10);

  pdf.text(
    "Authorized Signatory",
    50,
    y + 8,
    { align: "center" }
  );

  pdf.text(
    String(form?.userName || "Partner"),
    160,
    y + 8,
    { align: "center" }
  );

  pdf.text(
    "Think5Whys Global DeepTech Solutions Pvt Ltd",
    50,
    y + 15,
    { align: "center" }
  );

  pdf.text(
    "Partner Signature",
    160,
    y + 15,
    { align: "center" }
  );

  // ===== FOOTER =====

  pdf.setFontSize(8);

  pdf.text(
    "System Generated Agreement",
    pageWidth / 2,
    285,
    { align: "center" }
  );

  // ===== SAVE =====

  pdf.save(
    `Think5Whys-${role}-Agreement-${form?.userCode || "USER"}.pdf`
  );
};

  const handleWhatsAppShare = () => {
    let message = "";
    if (activeDocument === "CERTIFICATE") {
      message = `
  🏅 Think5Whys Certificate

  Name: ${form?.userName}
  User ID: ${form?.userCode}
  Role: ${selectedRole}

  This is an officially issued Think5Whys role certificate.

  🌐 www.think5whys.com
      `.trim();

    } else if (activeDocument === "AGREEMENT") {

      message = `
  📄 Think5Whys Partner Agreement

  Name: ${form?.userName}
  User ID: ${form?.userCode}
  Role: ${selectedRole}

  Agreement Type: ${selectedRole} Partner Agreement

  Valid From: ${agreement?.startDate}
  Valid Until: ${agreement?.endDate}

  🌐 www.think5whys.com
      `.trim();

    } else {
      return;
    }

    window.open(
      `https://wa.me/?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  const handleEmailShare = () => {

      let subject = "";
      let body = "";

      if (activeDocument === "CERTIFICATE") {

        subject = `Think5Whys ${selectedRole} Certificate`;

        body = `
    Hello,

    Please find my Think5Whys certificate details.

    Name: ${form?.userName}
    User ID: ${form?.userCode}
    Role: ${selectedRole}

    Issued By:
    Think5Whys Global DeepTech Solutions Private Limited

    Website:
    www.think5whys.com

    Regards,
    ${form?.userName}
        `.trim();

      } else if (activeDocument === "AGREEMENT") {

        subject = `Think5Whys ${selectedRole} Agreement`;

        body = `
    Hello,

    Please find my Think5Whys agreement details.

    Name: ${form?.userName}
    User ID: ${form?.userCode}
    Role: ${selectedRole}

    Agreement Type:
    ${selectedRole} Partner Agreement

    Valid From:
    ${agreement?.startDate}

    Valid Until:
    ${agreement?.endDate}

    Issued By:
    Think5Whys Global DeepTech Solutions Private Limited

    Website:
    www.think5whys.com

    Regards,
    ${form?.userName}
        `.trim();

      } else {
        return;
      }

      window.location.href =
        `mailto:?subject=${encodeURIComponent(subject)}` +
        `&body=${encodeURIComponent(body)}`;
  };
    
  const agreement = localSelectedRoleAgreement && generateAgreement({
      role: localSelectedRoleAgreement,
      userName: form?.userName,
      userCode: form?.userCode,
      city: form?.city,
      state: form?.state,
      country: form?.country,
      pincode: form?.pincode,
  });

  return (
    <div className="mt-4 p-3 rounded-xl border border-yellow-400 bg-yellow-500/10">
      <h3 className="text-yellow-300 font-semibold text-sm">
        🎖️ Certificates & Agreements Available
      </h3>
      <p className="text-xs text-gray-300 mt-1">
        Download or share your official Partner certificates & Partner Agreementsinstantly
      </p>
      <div className="flex flex-col gap-2 mt-3">
        {hasDirector && (
          <div className="grid grid-cols-2 gap-2">
            <button
              onClick={() => {
                setSelectedRole("DIRECTOR");
                setLocalSelectedRolePrint("DIRECTOR");
                setActiveDocument("CERTIFICATE");
              }}
              className="text-xs w-40 px-2 py-1 bg-blue-600 hover:bg-blue-700 text-white"
            >
              🏆 Director Certificate
            </button>
            <button
              onClick={() => {
                setSelectedRole("DIRECTOR");
                setLocalSelectedRoleAgreement("DIRECTOR");
                setActiveDocument("AGREEMENT");
              }}
              className="text-xs w-40 px-2 py-1 bg-blue-600 hover:bg-blue-700 text-white"
            >
              📄 Director Agreement
            </button>
          </div>
        )}

        {hasCoordinator && (
          <div className="grid grid-cols-2 gap-2">
            <button
              onClick={() => {
                setSelectedRole("COORDINATOR");
                setLocalSelectedRolePrint("COORDINATOR");
                setActiveDocument("CERTIFICATE");
              }}
              className="text-xs w-40 px-2 py-1 bg-blue-600 hover:bg-blue-700 text-white"
            >
              📋 Coordinator Certificate
            </button>

            <button
              onClick={() => {
                setSelectedRole("COORDINATOR");
                setLocalSelectedRoleAgreement("COORDINATOR");
                setActiveDocument("AGREEMENT");
              }}
              className="text-xs w-40 px-2 py-1 bg-blue-600 hover:bg-blue-700 text-white"
            >
              📄 Coordinator Agreement
            </button>
          </div>
        )}

        {hasInfluencer && (
          <button
            onClick={() => {
             setSelectedRole("INFLUENCER");
            setLocalSelectedRolePrint("INFLUENCER");
            setActiveDocument("CERTIFICATE");
            }}
            className="text-xs w-40 px-2 py-1 bg-blue-600 hover:bg-blue-700 text-white"
          >
            🌟 Influencer Certificate
          </button>
        )}
      </div>

      {/* ACTIONS */}
      <div className="grid grid-cols-5 gap-2 mt-4 items-center">
        <button
          type="button"
          onClick={() => {
            if (activeDocument === "CERTIFICATE") {
              handleDownloadPDF(selectedRole);
            }

            if (activeDocument === "AGREEMENT") {
              handleDownloadAgreement(selectedRole);
            }
          }}
        >
          📥
        </button>
        <button type="button" onClick={handleWhatsAppShare}>📲</button>
        <button type="button" onClick={handleEmailShare}>📧</button>
        <button
          type="button"
          onClick={() => setShowDocument(prev => !prev)}
          className="px-2 py-1 text-sm rounded-lg bg-gray-800 text-white hover:bg-gray-700"
        >
          {showDocument ? "🙈" : "👁"}
        </button>

      </div>

      {/* CERTIFICATE */}
      {showDocument && activeDocument === "CERTIFICATE" && (
        <div
          id="certificate-box"
          className="mt-4 p-5 rounded-2xl border border-yellow-400 bg-gradient-to-br from-black via-gray-900 to-black shadow-lg"
        >
          <div className="text-center">
            <img
              src={logo}
              alt="logo"
              className="h-14 w-14 mx-auto mb-2 rounded-full border border-yellow-400"
            />

            <h2 className="text-yellow-300 text-lg font-bold">
              🏅 Official Role Certificate
            </h2>

            <p className="text-xs text-gray-400">
              Think5Whys Global Certification Authority
            </p>
          </div>
          <div className="mt-4 text-center">
            <p className="text-white font-semibold">
              {form?.userName}
            </p>
            <p className="text-gray-400 text-xs">
              ID: {form?.userCode}
            </p>
          </div>
          <div className="mt-3 text-center">
            {localSelectedRolePrint ? (
              <span className="px-4 py-1 rounded-full bg-yellow-500 text-black font-bold text-sm">
                {localSelectedRolePrint} CERTIFICATE
              </span>
            ) : (
              <p className="text-xs text-gray-500">
                Select a role to generate certificate
              </p>
            )}
          </div>
          <div className="mt-4 flex justify-center">
            <div className="p-2 bg-white rounded-lg">
              <QRCode
                value={JSON.stringify({
                  name: form?.userName,
                  userCode: form?.userCode,
                  role: localSelectedRolePrint,
                })}
                size={120}
              />
            </div>
          </div>
          <div className="mt-4 text-center text-xs text-gray-400">
            System generated • Verified • Secure QR enabled
          </div>
        </div>
      )}

      {showDocument && activeDocument === "AGREEMENT" && agreement && (
          <div className="mt-6 bg-white text-black rounded-xl p-6 shadow-lg">

          <h2 className="text-xl font-bold text-center mb-4">
            {agreement.title}
          </h2>

          <pre
            className="whitespace-pre-wrap text-sm leading-6"
            style={{ fontFamily: "inherit" }}
          >
            {agreement.content}
          </pre>

        </div>
      )}

      {/* {showDocument &&
      activeDocument === "CERTIFICATE" && (
        <CertificateComponent />
      )}

      {showDocument &&
      activeDocument === "AGREEMENT" && (
        <AgreementComponent />
      )} */}
    </div>
  );
};

export default PDPartnerCertificate;